module.exports = __webpack_public_path__ + "static/media/utvyakta.cf68e66c.png";